import React from 'react';
import { BadgeCheck } from 'lucide-react';

const HeroContent = ({ onWatch }) => {
    return (
        <div className="max-w-xl flex flex-col gap-7 pt-0 md:pt-0 md:-mt-4 lg:-mt-8 items-center md:items-start text-center md:text-left cl-in">
            {/* eyebrow */}
            <span className="font-mono text-[11px] uppercase tracking-label text-textMuted">AI Customer Support Platform</span>

            {/* Headline */}
            <h1 className="text-5xl sm:text-6xl md:text-6xl lg:text-7xl font-bold tracking-head leading-[1.05] text-ink">
                Your <span className="font-serif-italic">AI</span><br />
                Customer <br /> Support <br />
                <span className="text-textSecondary">For Business</span>
            </h1>

            {/* Description */}
            <p className="text-[15px] text-textSecondary max-w-md leading-relaxed">
                Empower your business with an AI-driven support system that handles inquiries, syncs data across platforms, and automates workflows seamlessly.
            </p>

            {/* Watch the demo — the most prominent action in the hero */}
            <button
                onClick={onWatch}
                data-track="watch_demo"
                data-placement="hero"
                className="group inline-flex items-center gap-4 pl-2 pr-7 py-2 rounded-full bg-card border-2 border-ink shadow-hard hover:-translate-y-0.5 transition-all active:translate-x-[2px] active:translate-y-[2px]"
            >
                <span className="relative w-14 h-14 rounded-full bg-ink text-paper grid place-items-center">
                    <span className="absolute inset-0 rounded-full bg-ink animate-ping opacity-20" />
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="ml-1 relative"><path d="M7 5.5v13a1 1 0 0 0 1.5.86l11-6.5a1 1 0 0 0 0-1.72l-11-6.5A1 1 0 0 0 7 5.5z" /></svg>
                </span>
                <span className="text-lg font-bold tracking-head text-ink whitespace-nowrap">Watch the demo</span>
            </button>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-3 justify-center md:justify-start">
                <a href="#contact" className="inline-flex items-center justify-center bg-ink text-paper px-6 py-3 rounded-full text-sm font-semibold shadow-hard-soft hover:bg-black transition-all active:translate-x-[2px] active:translate-y-[2px]">
                    Get started
                </a>
                <a href="#solutions" className="inline-flex items-center justify-center bg-card text-textBody border border-borderLight px-6 py-3 rounded-full text-sm font-semibold hover:bg-bone transition-all">
                    See solutions
                </a>
            </div>

            {/* META Verified Tag */}
            <div className="w-fit flex items-center gap-2.5 bg-card border border-borderLight px-4 py-2 rounded-full shadow-hard-soft">
                <img src="/meta.png" alt="Meta" className="w-6 h-6 object-contain" />
                <span className="text-sm font-bold text-ink tracking-head">META Verified</span>
                <BadgeCheck className="w-4 h-4 text-success" />
            </div>
        </div>
    );
};

export default HeroContent;
